// import React, { useState } from 'react';
// import Header from './components/header/header';
// import HomePage from './components/home';
// import NewsPage from './components/news';
// import Footer from './components/footer/footer';
// import AppSettings from './settings';


// const Informe = ( props ) => {
// 	const [newsId, setNewsId] = useState(props)
// 	console.log(newsId)
//   return (
// 	<>
// 	  <div className="u-body u-stick-footer">
// 		<HomePage changePageHandler={(ev) => this.handleChangePage(ev)} />
// 		<NewsPage newsId={"72525103-c646-4f2a-9de3-6c96d1b620a7"} changePageHandler={(ev) => this.handleChangePage(ev)} />
//    		</div>
// 	</>
//   )
// }

// export default Informe



// export default class Informe extends React.Component {
// 	constructor(props) {
// 		super(props);
// 		if (props.newsId != undefined) {
// 			console.log(props)
// 			this.state = {
// 				page: AppSettings.pages.news,
// 				newsId: props.newsId
// 			}
// 		} else {
// 			console.log(props)
// 			this.state = {

// 				page: AppSettings.defaultPage,
// 				newsId: 0
// 			}
// 		}
// 	}

// 	render() {
// 		let content;

// 		switch (this.state.page) {
// 			case AppSettings.pages.news:
// 				content = <NewsPage newsId={this.state.newsId} changePageHandler={(ev) => this.handleChangePage(ev)} />
// 				break;
// 			default:
// 				content = <HomePage changePageHandler={(ev) => this.handleChangePage(ev)} />
// 		}


// 		return (
// 			<div className="u-body u-stick-footer">
// 				<Header />
// 				{content}
// 				<Footer />
// 			</div>
// 		);
// 	}

// 	handleChangePage(ev) {
// 		var newsId = 0;
// 		window.scrollTo(0, 0);
// 		var page = ev.page;

// 		// Clear query string
// 		window.history.pushState({}, document.title, document.location.origin);

// 		// Handle each page
// 		switch (page) {
// 			case AppSettings.pages.news:
// 				newsId = ev.newsId;
// 				break;
// 		}

// 		this.setState({
// 			page: page,
// 			newsId: newsId
// 		});
// 	}
// }
